import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ServiceNowAgentConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AIAgentService } from './api/aIAgent.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ServiceNowAgentApiModule {
    public static forRoot(configurationFactory: () => ServiceNowAgentConfiguration): ModuleWithProviders<ServiceNowAgentApiModule> {
        return {
            ngModule: ServiceNowAgentApiModule,
            providers: [ { provide: ServiceNowAgentConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ServiceNowAgentApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ServiceNowAgentApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
